export default __webpack_public_path__ + "static/media/home-decor-img-14.3f4c2fe6.png";